/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { useCallback } from 'react';
import useConfig from './useConfig.js';
import { EAnimationType } from '../config-provider/ConfigContext.js';
import '../_chunks/dep-8bcc0e9b.js';
import '../_chunks/dep-6b7c7d34.js';
import '../_chunks/dep-248ede8a.js';
import 'lodash-es';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-35c2a089.js';
import '../_chunks/dep-fad4e87b.js';
import 'dayjs';
import '../_chunks/dep-81c9c3a2.js';
import '../_common/js/global-config/default-config.js';

function useAnimation() {
  var _useConfig = useConfig(),
    animation = _useConfig.animation;
  var expand = EAnimationType.expand,
    ripple = EAnimationType.ripple,
    fade = EAnimationType.fade;
  var keepAnimation = useCallback(function (type) {
    var _animation$exclude, _animation$include;
    return animation && !((_animation$exclude = animation.exclude) !== null && _animation$exclude !== void 0 && _animation$exclude.includes(type)) && ((_animation$include = animation.include) === null || _animation$include === void 0 ? void 0 : _animation$include.includes(type));
  }, [animation]);
  return {
    keepExpand: keepAnimation(expand),
    keepRipple: keepAnimation(ripple),
    keepFade: keepAnimation(fade)
  };
}

export { useAnimation as default };
//# sourceMappingURL=useAnimation.js.map
